/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Vibebids_ClicksInputs */

const en_directory_vibebids_clicks = /** @type {(inputs: Directory_Vibebids_ClicksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} clicks`)
};

const zh_directory_vibebids_clicks = /** @type {(inputs: Directory_Vibebids_ClicksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次点击`)
};

/**
* | output |
* | --- |
* | "{count} clicks" |
*
* @param {Directory_Vibebids_ClicksInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_clicks = /** @type {((inputs: Directory_Vibebids_ClicksInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_ClicksInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_clicks(inputs)
	return zh_directory_vibebids_clicks(inputs)
});
export { directory_vibebids_clicks as "directory.vibebids.clicks" }